<template>
    <div class="qf-filter-box d-flex flex-column pt-1 text-left">
        <div class="mb-3 px-1 small">
            <input type="text" :placeholder="$ml.get('Search')"
                   v-model="filterByInput"/>
            <a href="#!" class="badge badge-secondary mr-1"
               v-for="(brand, index) in filterByCheck"
               @click.prevent="removeFromList(index)"
               :key="`shown${uniqueKey}${index}`">{{brand}}</a>
        </div>
        <div class="qf-filter-results px-1 pb-1 qf-smaller">
            <div class="d-flex align-items-center mb-2"
                 v-for="(uniqueBrand, index) in uniqueBrands" :key="`unique${uniqueKey}${index}`">
                <div class="mr-1">
                    <label class="qf-checkbox mb-0">
                        <input type="checkbox" :name="`filterBy${uniqueKey}`"
                               :id="`filterBy${uniqueKey}${index}`"
                               v-model="filterByCheck" :value="uniqueBrand"
                               @change="emitChange">
                        <font-awesome-icon icon="check"/>
                    </label>
                </div>
                <div class="flex-grow-1">
                    <label :for="`filterBy${uniqueKey}${index}`" class="mb-0 qf-cursor-pointer">
                        {{uniqueBrand}}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TableFilter",
        props: {
            filterArray: Array,
            uniqueKey: String
        },
        data() {
            return {
                filterByInput: '',
                filterByCheck: [],
            }
        },
        computed: {
            uniqueBrands() {
                let uniqueBrands = this.filterArray.filter(string => {
                    return (string !== undefined) && string.toLowerCase().includes(this.filterByInput.toLowerCase());
                });
                return uniqueBrands;
            },
        },
        mounted() {
            if (this.$route.query.owner && this.uniqueKey == 'Owner') {
                let owner = this.$route.query.owner.split('|')
                owner.forEach(element => {
                  this.filterByCheck.push(element)
                  this.$emit('changeOfValue', this.filterByCheck, this.uniqueKey) 
                });
            }
            if (this.$route.query.status && this.uniqueKey == 'Status') {
                let status = this.$route.query.status.split('|')
                status.forEach(element => {
                  this.filterByCheck.push(element)
                  this.$emit('changeOfValue', this.filterByCheck, this.uniqueKey) 
                });
            }
            if (this.$route.query.brand && this.uniqueKey == 'Brand') {
                let brand = this.$route.query.brand.split('|')
                brand.forEach(element => {
                  this.filterByCheck.push(element)
                  this.$emit('changeOfValue', this.filterByCheck, this.uniqueKey) 
                });
            }
            if (this.$route.query.earlierTrademark && this.uniqueKey == 'EarlierTrademark') {
                let earlierTrademark = this.$route.query.earlierTrademark.split('|')
                earlierTrademark.forEach(element => {
                  this.filterByCheck.push(element)
                  this.$emit('changeOfValue', this.filterByCheck, this.uniqueKey) 
                });
            }
        },
        methods: {
            removeFromList(index) {
                console.log(index);
                console.log(this.filterByCheck);
                this.filterByCheck.splice(index, 1);
                console.log(this.filterByCheck);
                this.emitChange();
            },
            emitChange() {
                this.$emit('changeOfValue', this.filterByCheck, this.uniqueKey);
            }
        }
    }
</script>

<style scoped>
    .badge {
        white-space: normal;
    }
</style>
